import api, { request } from '../../../../api';
import { IStore } from '../../../index';

export const createGroup = async (state: IStore, clubID: number | string, data: any) => {
  const response = await request.post(`${api.admin.clubs}${clubID}/groups/`, data);

  if (response.error) {
    return { errors: { groups: { msg: 'Error creating the club group' } } };
  }

  return {
    adminGroups: {
      groups: state.adminGroups.groups.concat([response])
    }
  };
};
